import styled from '@emotion/styled'
import tw from 'twin.macro'
import { Collapsible } from '#src/products/components/collapsible-section'

export const Item = styled(Collapsible.Item)`
  ${tw`bg-grey-100 mt-4 sm:mt-0`}
`

export const Button = styled(Collapsible.Button)`
  ${tw`
    w-full px-5 lg:px-3 no-underline text-grey-700 justify-end
    hover:text-pretRed-700 focus:text-pretRed-700
  `}
  &:focus {
    ${tw`pret-outline outline-compact shadow-none`}
  }
  ${tw`leading-6 py-3 lg:py-2 text-sm`}
`

export const Content = styled('div')`
  ${tw`p-5 pt-5  bg-white`}
`
